import { useEffect, useRef, useState } from 'react';

import type { SocialProofTileProps } from '../SocialProofTile';

/*
 * Checks if the static row of tiles is overflowing the container,
 * and returns the refs to attach plus the resulting `isOverflowing` state.
 */
export const useOverflowDetection = (columns: SocialProofTileProps[][]) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rowOfTilesRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const rowOfTiles = rowOfTilesRef.current;

    if (!container || !rowOfTiles) return;

    const checkOverflow = () => {
      const rowOfTilesWidth = rowOfTiles.scrollWidth;
      const displayableWidth = container.clientWidth;

      setIsOverflowing(rowOfTilesWidth > displayableWidth);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);

    resizeObserver.observe(container);
    resizeObserver.observe(rowOfTiles);

    return () => resizeObserver.disconnect();
  }, [columns]);

  return {
    containerRef,
    rowOfTilesRef,
    isOverflowing,
  };
};
